import React, { useMemo } from "react";
import { useLandingLang } from "../../i18n/LandingLangContext";

export function ClientsMarquee({ clients = [], resolveLogo }) {
  const { t } = useLandingLang();
  // Duplicamos la lista para crear el efecto de loop infinito (igual que en la plantilla)
  const loopItems = useMemo(() => {
    const base = Array.isArray(clients) ? clients : [];
    return [...base, ...base];
  }, [clients]);

  return (
    // Sección con padding, fondo blanco y borde inferior suave
    <section className="py-12 bg-white border-b border-slate-100 relative overflow-hidden text-center">
      {/* Cabecera */}
      <div className="max-w-7xl mx-auto px-6 mb-8">
        <span className="text-sky-500 !font-black tracking-widest uppercase text-xs">
          {t("trustTag")}
        </span>
      </div>

      {/* Contenedor Animado (usa la clase definida en index.css) */}
      <div className="flex animate-marquee">
        {loopItems.map((c, idx) => {
          // Lógica para evitar keys duplicadas en React al renderizar doble lista
          const uniqueKey = `${c?.name || "client"}-${idx}`;

          // Resolver logo
          const logoSrc =
            c?.logoKey && typeof resolveLogo === "function"
              ? resolveLogo(c.logoKey)
              : null;

          return (
            <div
              key={uniqueKey}
              // Estilos del Item: flex vertical, padding lateral, separador derecho
              className="flex flex-col items-center gap-4 px-12 border-r border-slate-50 last:border-0 group cursor-default"
            >
              {/* CAJA DEL LOGO 
                  Estilos: w-40 h-20, bordes redondeados, sombra suave
                  Hover: Borde azul cielo y sombra media
              */}
              <div className="w-40 h-20 bg-white rounded-2xl border border-slate-100 shadow-sm flex items-center justify-center p-4 transition-all duration-500 group-hover:shadow-md group-hover:border-sky-100">
                {logoSrc ? (
                  <img
                    src={logoSrc}
                    alt={c.name}
                    // Imagen se escala un 5% al hacer hover
                    className="max-h-full max-w-full object-contain transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                ) : (
                  // Fallback si no hay logo
                  <span className="text-[10px] !font-bold text-slate-300 uppercase text-center leading-tight">
                    {t("reviPartner")}
                  </span>
                )}
              </div>

              {/* NOMBRE DEL CLIENTE 
                  Estilos: Texto pequeño, muy grueso (!font-black), gris claro que pasa a oscuro en hover
              */}
              <div className="h-10 flex items-start justify-center px-2">
                <span className="text-[10px] !font-black text-slate-400 group-hover:text-slate-600 transition-colors uppercase tracking-[0.15em] text-center max-w-[160px] leading-tight block">
                  {c?.name}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
